module.exports = __webpack_public_path__ + "static/media/me.51c952bb.jpg";